import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "./themes";
import { PostHogProvider } from "posthog-js/react";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <ThemeProvider theme={defaultTheme}>
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          defaults: "2025-11-30",
          capture_exceptions: true,
          debug: process.env.NODE_ENV === "development",
        }}
      >
        <App />
      </PostHogProvider>
    </ThemeProvider>
  </BrowserRouter>
);
registerServiceWorker();
